import { render, staticRenderFns } from "./SobreMiCompont.vue?vue&type=template&id=4bb63ccc&"
import script from "./SobreMiCompont.vue?vue&type=script&lang=js&"
export * from "./SobreMiCompont.vue?vue&type=script&lang=js&"
import style0 from "./SobreMiCompont.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports